import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Triggers a clean fade-in on every route change. Wraps <Routes> and rekeys
 * its container by pathname, so React unmounts/remounts and the CSS animation
 * fires for the new page. Honors prefers-reduced-motion via the .page-fade
 * rule in index.css.
 */
export const RouteTransition = ({ children }) => {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="page-fade" data-testid="route-transition">
      {children}
    </div>
  );
};

export default RouteTransition;
